import { render, staticRenderFns } from "./settingparams.vue?vue&type=template&id=418ab762&"
import script from "./settingparams.vue?vue&type=script&lang=ts&"
export * from "./settingparams.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "settingparams.vue"
export default component.exports